import React, { FC, useMemo, useCallback, useState, useEffect } from "react"
import { useRequest } from "ahooks"
import { getTags } from "@/api"
import Map from "@components/Map"
import TreeMap from "@components/TreeMap"
import CloudWorld from "@components/CloudWorld"
import BarTop from "@components/Bar/top"
import Selector from "@components/Selector"
import Env from "@util/env"
import Loading from "@/components/Loading"
import Block from "@/components/BlockWrap"
import { getScatterSeries, getFlyLineSeries } from "@util/chart"

import "./index.scss"
import { useSetState } from "@/reactUse"
const islandConf = {
  name: "张江AI智能岛",
  center: [121.609608, 31.185499],
}
const InitialCenter = [121.608801296660304, 31.184597642924776]

const Graph: FC<any> = ({ asComp, onChangeMapState, flyItem, flyActive }) => {
  // const { data, loading } = useRequest(previewReport, {})
  const InitialZoom = 20

  const { data, loading } = useRequest(getTags, {})
  const [state, setState] = useSetState({
    series: [],
    zoom: InitialZoom,
    center: InitialCenter,
    currentIdx: 0,
  })
  const tabs = useMemo(() => {
    return [
      { name: "来源城市", key: "fromCity", color: "#00FFDB" },
      { name: "出差城市", key: "toCity", color: "#00FFDB" },
    ]
  }, [])
  const { tags, fromCity, toCity, rank } = useMemo(() => {
    if (!data) {
      return {}
    }
    let t = []
    let tMap = {}
    let fromCity = []
    let toCity = []
    data.forEach((item: any) => {
      if (item.id === "104004") {
        fromCity = item.tags
        item.tags.forEach((tag) => {
          tag.fromName = tag.name
          tag.toName = islandConf.name
          tag.coords = [[tag.lon, tag.lat], islandConf.center]
        })
      } else if (item.id === "106013") {
        toCity = item.tags
        item.tags.forEach((tag) => {
          tag.fromName = islandConf.name
          tag.toName = tag.name
          tag.coords = [islandConf.center, [tag.lon, tag.lat]]
        })
      }
      item.tags.forEach((tag) => {
        if (!tMap[tag.name]) {
          t.push({ name: tag.name, value: tag.count })
        } else {
          let _tag = tMap[tag.name]
          _tag.value = Math.max(_tag.value, tag.count)
        }
      })
    })

    return {
      tags: t,
      fromCity,
      toCity,
      rank: [
        { name: "复旦大学张江校区", value: 0.99 },
        { name: "上海科技大学", value: 0.8 },
        { name: "复旦大学药学院", value: 0.7 },
        { name: "上海中医药大学", value: 0.65 },
        { name: "同济大学嘉定校区", value: 0.6 },
      ],
    }
  }, [data])

  const onClickFlyModel = useCallback(
    (item, active) => {
      let list = null
      let series = []
      let zoom = InitialZoom
      let center = InitialCenter
      if (!active || !item) {
        // setState({
        series = [
          getScatterSeries("scatter", []),
          ...getFlyLineSeries("fly", []),
        ]
        //   zoom: InitialZoom,
        //   center: InitialCenter,
        // })
        // series = []
      } else if (item.key === "fromCity") {
        list = fromCity
      } else if (item.key === "toCity") {
        list = toCity
      }
      if (list) {
        center = [0, 0]
        zoom = 4
        list.forEach((item) => {
          center[0] += item.lon
          center[1] += item.lat
        })
        let len = list.length
        center = [center[0] / len, center[1] / len]
        series = [
          getScatterSeries("scatter_" + item.key, list, "#FF5555"),
          ...getFlyLineSeries("fly_" + item.key, list, item.color, true),
        ]
        zoom = Env.getScale() + zoom
      }
      onChangeMapState
        ? onChangeMapState({ series, zoom, center })
        : setState({ series, zoom, center })
    },
    [fromCity, toCity, onChangeMapState]
  )
  useMemo(() => {
    if (fromCity) {
      onClickFlyModel(tabs[0], true)
    }
  }, [fromCity, onClickFlyModel, tabs])
  useMemo(() => {
    onClickFlyModel(flyItem, flyActive)
  }, [flyItem, flyActive])
  useEffect(() => {
    onChangeMapState &&
      onChangeMapState({ series: [], zoom: InitialZoom, center: InitialCenter })
  }, [onChangeMapState])
  if (!data) {
    return <Loading loading={loading} tip="正在获取报告数据" />
  }
  return (
    <div className="pg-graph flex">
      <div className="col-left">
        <div className="row flex">
          <Block className="block-map">
            {!asComp && (
              <Selector
                icon
                tabs={tabs}
                onClick={onClickFlyModel}
                currentIdx={state.currentIdx}
              />
            )}
            {!asComp && (
              <Map
                indoorVisible={true}
                series={state.series}
                zoom={state.zoom}
                center={state.center}
                onChangeMapState={setState}
              />
            )}
          </Block>
        </div>
        <div className="row flex">
          <Block className="block-top" title="高校/科研机构交流度">
            {rank && <BarTop data={rank} />}
          </Block>
          <Block className="block-tag" subTitle="用户标签">
            <CloudWorld data={tags} />
          </Block>
        </div>
      </div>
      <div className="col-right">
        <Block className="block-from" subTitle="区域人才吸引度 ">
          <TreeMap data={fromCity} />
        </Block>
        <Block className="block-to" subTitle="区域人才对外交流度">
          <TreeMap data={toCity} />
        </Block>
      </div>
    </div>
  )
}

export default Graph
